export class LicenseService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getLicenses(options) {
    return this.apiService.get('/licenses', options);
  }

  getLicenseById(id) {
    return this.apiService.get(`/licenses/${id}`);
  }

  createLicense(data) {
    return this.apiService.post('/licenses', data);
  }

  updateLicense(id, data) {
    return this.apiService.put(`/licenses/${id}`, data);
  }

  exportLicense(licenseId) {
    return this.apiService.download(`/licenses/${licenseId}/export`, 'license.txt');
  }

  removeLicense(licenseId) {
    return this.apiService.delete(`/licenses/${licenseId}`);
  }
}
